var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgH1ELearning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 13H14a4 4 0 00-4 4v31a4 4 0 004 4h22v7H25v4h26v-4H40v-7h22a4 4 0 004-4V17a4 4 0 00-4-4zm0 35H14V17h48v31zM37 37h-3v8h-8V34h10.2l5.07-7.26a1.501 1.501 0 012.46 1.72l-5.52 7.9A1.5 1.5 0 0137 37zm-7.23-5.31a3.2 3.2 0 112.06-.76 3.17 3.17 0 01-2.08.76h.02zM19 20h37v25H37v-3h16V23H22v12h-3V20z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/H1_ELearning.ee1faa08.svg";
export { SvgH1ELearning as ReactComponent };